import React from 'react';
import {useLocalization} from 'localization';
import {Icon} from '../icons';
import type { ActionButtonV2Props} from './ActionButtonV2';
import {ActionButtonV2} from './ActionButtonV2';

export const DeleteButtonV2: React.FC<ActionButtonV2Props> = props => {
  const {t} = useLocalization();

  return (
    <ActionButtonV2
      showSpinnerOnClick
      startIcon={<Icon icon={'Delete'} />}
      title={t('general.delete')}
      color={'error'}
      {...props}>
      {t('general.delete')}
    </ActionButtonV2>
  );
};
